import { render, staticRenderFns } from "./RecuperacionContrasenia.vue?vue&type=template&id=53146a18"
import script from "./RecuperacionContrasenia.vue?vue&type=script&lang=js"
export * from "./RecuperacionContrasenia.vue?vue&type=script&lang=js"
import style0 from "./RecuperacionContrasenia.vue?vue&type=style&index=0&id=53146a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports